import type { App } from 'vue'
import type { RouteRecordRaw } from 'vue-router'

// layouts
import MainLayout from '@/layouts/MainLayout.vue'
import SignUp from '@/layouts/SignUp.vue'

export function getRoutes(_app: App): RouteRecordRaw[] {
  return [
    // 🔹 публічний layout (без авторизації)
    {
      path: '/signup',
      component: SignUp,
      children: [
        {
          path: 'institution-creation',
          name: 'trialSignUp',
          component: () => import('@/views/signup/TrialSignUP.vue'),
          meta: { roles: ['public'] }
        },
        {
          path: ':token',
          name: 'signup',
          props: true,
          component: () => import('@/views/signup/SignUP.vue'),
          meta: { roles: ['public'] }
        }
      ]
    },
    {
      path: '/expired',
      name: 'expired',
      component: () => import('@/views/Expired.vue'),
      meta: { roles: ['public'] }
    },
    {
      path: '/billing-plans-separate', name: 'BillingPlansSeparate',
      component: () => import('@/views/BillingPlans.vue'),
      meta: { roles: ['public'] }
    },
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: '', name: 'Home',
          component: () => import('@/views/dashboards/index.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'billing-plans', name: 'BillingPlans',
          component: () => import('@/views/BillingPlans.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'departments', name: 'Departments',
          component: () => import('@/views/departments/index.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'institutions', name: 'Institutions',
          component: () => import('@/views/institutions/index.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'users', name: 'Users',
          component: () => import('@/views/users/index.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'nurse-location', name: 'NurseLocation',
          component: () => import('@/views/nurses/NursesLocation.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'reinviteusers', name: 'ReInviteUsers',
          component: () => import('@/views/users/ReInviteUser.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'scheduling', name: 'Scheduling',
          component: () => import('@/views/scheduling/index.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'procedures', name: 'Procedures',
          component: () => import('@/views/procedures/index.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'patients', name: 'Patients',
          component: () => import('@/views/patients/PatientsView.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'visits-list', name: 'VisitForms',
          component: () => import('@/views/visitsList/VisitsList.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'visit-report/:visitId/:patientId', name: 'VisitReport', props: true,
          component: () => import('@/views/visitsList/VisitReport.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'patient/:patientId', name: 'Patient', props: true,
          component: () => import('@/views/patients/PatientComponents/PatientView.vue'),
          meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'add-patient', name: 'AddPatient',
          component: () => import('@/views/patients/AddPatientComponents/AddPatient.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'edit-patient/:patientUId', name: 'EditPatient', props: true,
          component: () => import('@/views/patients/AddPatientComponents/AddPatient.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'procedure/:code', name: 'Procedure', props: true,
          component: () => import('@/views/procedure/index.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'procedure/:procedureId/step/:stepId', name: 'Step', props: true,
          component: () => import('@/views/step/index.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'study', name: 'Study',
          component: () => import('@/views/study/StudyList.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'study/:id', name: 'StudyView', props: true,
          component: () => import('@/views/study/StudyView.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'studyresults', name: 'StudyResults',
          component: () => import('@/views/study/StudyResults.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'surveyresults/:surveyId', name: 'SurveyResults', props: true,
          component: () => import('@/views/study/SurveyResults.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'userresults/:userId/survey/:resultId', name: 'UserResults', props: true,
          component: () => import('@/views/study/UserResults.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'survey/:id', name: 'Survey', props: true,
          component: () => import('@/views/study/SurveyView.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'learningobject', name: 'LearningObjects',
          component: () => import('@/views/learningObject/index.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'learningobject/:id', name: 'LearningObjectDetail', props: true,
          component: () => import('@/views/learningObject/detailView.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'devices', name: 'Devices',
          component: () => import('@/views/devices/DevicesView.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'device/:id', name: 'Device', props: true,
          component: () => import('@/views/device/DeviceView.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'groups', name: 'Groups',
          component: () => import('@/views/groups/GroupsView.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'group/:id', name: 'Group', props: true,
          component: () => import('@/views/group/GroupView.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'group/add', name: 'GroupAdd',
          component: () => import('@/views/group/CreateGroup.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'device-reports', name: 'DeviceReports',
          component: () => import('@/views/deviceReports/DeviceReportsView.vue')
          , meta: { roles: ['user', 'admin'] }
        },
        {
          path: 'device-charts', name: 'DeviceCharts',
          component: () => import('@/views/deviceCharts/DeviceChartsView.vue')
          , meta: { roles: ['user', 'admin'] }
        },
      ]
    },

    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
}
